import { apiInstance } from '@diamond/shared/utils';

export const deleteBanner = async (token: string, id: string) => {
  return await apiInstance(token).delete(`/backoffice/banner/${id}`);
};
